import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { take } from 'rxjs/operators';
import { DocentesDependenciaUaaDto } from 'src/app/dto/docentes-dependencia-uaa-dto';
import { EvadocInfoDto } from 'src/app/dto/evadoc-info-dto';
import { PersonaDto } from 'src/app/dto/persona-dto';
import { Persona } from 'src/app/model/persona';
import { DocenteService } from 'src/app/services/docente.service';
import { EvadocDocenteService } from 'src/app/services/evadoc-docente.service';
import { PersonaService } from 'src/app/services/persona.service';
import { UaaService } from 'src/app/services/uaa.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-seleccion',
  templateUrl: './seleccion.component.html',
  styleUrls: ['./seleccion.component.css']
})
export class SeleccionComponent implements OnInit {

  mensaje: number;
  periodoNombre: string;
  form: FormGroup;
  load: boolean;
  registrationLoad: boolean = false;
  DocentesPar: DocentesDependenciaUaaDto[];
  dataSource = new MatTableDataSource<DocentesDependenciaUaaDto>([]);
  displayedColumns: string[] = ['check', 'identificacion', 'docente'];
  validacionLista: DocentesDependenciaUaaDto[] = [];
  lstParaEnviar: EvadocInfoDto[] = [];
  listaInicialInfoDto: EvadocInfoDto[] = [];

  constructor(
    private uaaService: UaaService,
    private fb: FormBuilder,
    private docenteService: DocenteService,
    private evaDocService: EvadocDocenteService,
  ) { }

  ngOnInit() {
    this.uaaService.currentData.subscribe(data => {
    });
    this.InitForm();
  }

  InitForm() {
    this.form = this.fb.group({
      identificacion: new FormControl('', [
        Validators.required,
        Validators.pattern('^([A-Za-z][0-9]{5,9}|[0-9]{6,10})$'), // Una letra + números (6-10) o solo números (6-10)
        Validators.minLength(6),
        Validators.maxLength(10)
      ])
    });

  }

  docenteporIdentificacion() {
    this.DocentesPar = [];
    this.load = true;
    // take(1): toma el valor actual del BehaviorSubject y completa la suscripción
    // Evita acumulación de suscripciones que causan callbacks múltiples
    this.uaaService.currentData.pipe(take(1)).subscribe((data) => {
      this.docenteService.obtenerDocenteIdentificacion(this.form.value.identificacion, data.periodo).subscribe(data => {
        if (data.length > 0) {
          this.DocentesPar = data;
          this.load = false;
          this.dataSource = new MatTableDataSource<DocentesDependenciaUaaDto>(this.DocentesPar);
        } else {
          this.load = false;
          Swal.fire({
            icon: 'error',
            title: '!Docente no encontrado!',
            text: 'La identificación ingresada no corresponde a ningún docente.',
            confirmButtonColor: '#8F141B',
          })
        }
      }, (err: HttpErrorResponse) => {
        this.load = false;
        this.registrationLoad = false;
        if (err.status == 400) {
          this.load = false;
          Swal.fire({
            icon: 'error',
            title: '¡Docente evaluado o registrado!',
            text: 'Por favor registrar otro docente.',
            confirmButtonColor: '#8F141B',
            confirmButtonText: "Aceptar"
          })
        }
      })
    })
  }

  checkClick(docente: DocentesDependenciaUaaDto) {
    if (this.validacionLista.indexOf(docente) == -1) {
      this.validacionLista.push(docente);
      this.enviarCheck();
    } else {
      this.validacionLista = this.validacionLista.filter(k => k != docente)
    }
  }

  // Bulk Mode Properties
  bulkMode: boolean = false;
  bulkInput: string = '';
  bulkLoading: boolean = false;
  bulkProgress: number = 0;
  bulkFound: DocentesDependenciaUaaDto[] = [];
  bulkErrors: string[] = [];

  // Existing ...
  enviarCheck() {
    this.registrationLoad = true;
    this.lstParaEnviar = [];
    this.processRegistrationList(this.validacionLista);
  }

  // Refactored registration logic to keep it DRY
  processRegistrationList(docentes: DocentesDependenciaUaaDto[]) {
    if (docentes.length === 0) return;

    // take(1): evita suscripciones acumuladas al BehaviorSubject
    this.uaaService.currentData.pipe(take(1)).subscribe((data) => {
      let payload: EvadocInfoDto[] = [];

      docentes.forEach(element => {
        let dto: EvadocInfoDto = new EvadocInfoDto();
        let docente: Persona = new Persona();
        docente.codigo = element.codigoPersona;

        dto.docente = docente;
        dto.uaa = data.uaa;
        payload.push(dto);
      });

      this.evaDocService.GuardarDocentes(payload).subscribe((res) => {
        let title = docentes.length > 1
          ? '¡Docentes Registrados!'
          : '¡Docente Registrado!';

        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: title,
          text: `Se han procesado ${docentes.length} registros exitosamente.`,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          window.location.reload();
        });
      }, (err) => {
        this.registrationLoad = false;
        this.bulkLoading = false;
        Swal.fire('Error', 'Hubo un problema al registrar los docentes. Verifique si alguno ya está asignado.', 'error');
      });
    });
  }

  toggleMode() {
    this.bulkMode = !this.bulkMode;
    this.bulkInput = '';
    this.bulkFound = [];
    this.bulkErrors = [];
    this.DocentesPar = []; // Clear individual search
  }

  async procesarCargaMasiva() {
    if (!this.bulkInput.trim()) return;

    this.bulkLoading = true;
    this.bulkFound = [];
    this.bulkErrors = [];
    this.bulkProgress = 0;

    const ids = this.bulkInput.split(/[\n,\s]+/).map(id => id.trim()).filter(id => id.length >= 6);
    const uniqueIds = [...new Set(ids)];
    const total = uniqueIds.length;
    let finished = 0;

    if (total === 0) {
      this.bulkLoading = false;
      return;
    }

    // take(1): evita suscripciones acumuladas al BehaviorSubject
    this.uaaService.currentData.pipe(take(1)).subscribe((uaaData) => {
      uniqueIds.forEach(id => {
        this.docenteService.obtenerDocenteIdentificacion(id, uaaData.periodo).subscribe(
          (data) => {
            if (data && data.length > 0) {
              // Avoid duplicates in found list
              const exists = this.bulkFound.some(d => d.identificacion === data[0].identificacion);
              if (!exists) {
                this.bulkFound.push(data[0]);
              }
            } else {
              this.bulkErrors.push(id);
            }
            this.updateProgress(++finished, total);
          },
          (err) => {
            this.bulkErrors.push(id);
            this.updateProgress(++finished, total);
          }
        );
      });
    });
  }

  updateProgress(current: number, total: number) {
    this.bulkProgress = Math.round((current / total) * 100);
    if (current === total) {
      this.bulkLoading = false;
    }
  }

  registrarMasivo() {
    if (this.bulkFound.length === 0) return;
    this.bulkLoading = true; // Block UI
    this.processRegistrationList(this.bulkFound);
  }

  removerDeListaMasiva(docente: DocentesDependenciaUaaDto) {
    this.bulkFound = this.bulkFound.filter(d => d !== docente);
  }
}